
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

import japan from "../../assets/japan.jpg"
import magyar from "../../assets/magyar.png"
import arrow from "../../assets/arrow.png"

function MagyarJapan({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Magyar japán fordító</title>
                <meta name='description' content="Ingyenes magyar japán fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Magyar japán fordító" />
                <link rel="canonical" href="https://online-fordito.hu/magyar-japan-fordito" />
            </Helmet>
            <h1>Magyar japán fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>


                <div className="sectionhead">
                    <h2>A magyar és japán nyelv </h2>
                    <img src={magyar} alt="magyar zászló"></img>
                    <img src={japan} alt="japán zászló"></img>
                </div>


                <p>A magyar és a japán nyelv két különböző nyelv, amelyek különböző nyelvcsaládokba tartoznak. A magyar ugor-altaikus nyelvcsaládba tartozik, míg a japán egyedülálló nyelvcsalád, az izolált japán nyelvcsaládba.</p>

                <h3>Hasonlóságok</h3>


                <ul>
                    <li><b>Hangrendszerek</b>: Mind a magyar, mind a japán nyelv rendelkezik hangrendszerekkel. A magyarban a szavakat magas és mély hangrendekre osztjuk, míg a japánban a hangok hosszúsága és a hangsúlyos magánhangzók különböző kiejtési formákat eredményeznek.</li>

                    <li><b>Ragok</b>: Mind a magyar, mind a japán nyelv gazdag ragozó nyelvek. Mindkét nyelvben a szavaknak többféle alakja van a különböző esetekben, időkben vagy birtokviszonyokban.</li>

                    <li><b>Formális és udvariassági kifejezések</b>: Mind a magyar, mind a japán nyelvben fontos szerepet játszanak a formális és udvariassági kifejezések. Mindkét nyelvben megvannak a megfelelő kifejezések a különböző szociális helyzetekben való beszédhez.</li>
                </ul>



                <h3>Különbségek</h3>
                <ul>
                    <li><b>Nyelvcsalád és rokonság</b>: A magyar és a japán nyelv nem tartozik ugyanahhoz a nyelvcsaládhoz. A magyar ugor-altaikus, míg a japán egyedülálló nyelvcsaládba tartozik.</li>

                    <li><b>Hangzások és kiejtés</b>: A magyar és a japán nyelvnek eltérő hangzásai és fonetikai rendszerei vannak. A japán nyelvben például vannak jellemző hangzók, mint a hiragana és katakana írásrendszerben, amelyek a magyar nyelvben nem léteznek.</li>

                    <li><b>Írásrendszer</b>: A magyar nyelv latin betűs írásrendszert használ, míg a japán nyelv többféle írásrendszerrel rendelkezik, beleértve a kanjit (kínai eredetű karakterek), a hiraganát és a katakanát.</li>

                    <li><b>Nyelvtani struktúra</b>: A magyar és a japán nyelv nyelvtani struktúrája jelentősen eltérő. A magyar nyelvben a mondatok szerkezete gyakran más, mint a japánban. Például a szórend, a ragozás és a névmások használata eltérő lehet.</li>

                    <li><b>Szókincs</b>: A magyar és a japán nyelvnek teljesen eltérő szókincse van. A témakörökben, mint például az étel, az állatok vagy a növények, a két nyelv szókincse különböző lehet.</li>

                </ul>




                <div className="sectionbottom">
                    <Link to="/japan-magyar-fordito">Japán magyar fordító</Link>
                    <img src={japan} alt="japán zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>
                </div>
            </section>
        </>

    )
}

export default MagyarJapan;